export const CMS_URL = "https://admin.s-harrison.co.uk/wp-json/";
export const GRAVITY_FORMS_PUBLIC_KEY = "29884c3b09";
export const GRAVITY_FORMS_PRIVATE_KEY = "ffc59bd8a9147b8";



// WEBPACK FOOTER //
// ./src/constants/cmsData.js